// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"594":"about","964":"product"}[chunkId] + "." + {"594":"5bc9de0f","964":"811f27c7"}[chunkId] + ".css";
};